import React from 'react';
import BannerSlider from '../components/banner/BannerSlider';

const Accessories = () => {
  const heroSlides = [
    { label: 'Cufflinks Catalog', src: '/images/acc-cufflinks-catalog.webp' },
    { label: 'Ties Catalog', src: '/images/acc-ties-catalog.webp' },
    { label: 'Pocket Squares', src: '/images/acc-pocket-squares.webp' },
    { label: 'Lapel Pins', src: '/images/acc-lapel-pins.webp' },
    { label: 'Bow Ties', src: '/images/acc-bowties.webp' },
  ];

  const products = [
    { name: 'Silk Tie', img: '/images/acc-silk-tie-single.webp', backImg: '/images/acc-silk-tie-back.webp' },
    { name: 'Pocket Square', img: '/images/acc-pocket-squares.webp', backImg: '/images/acc-pocket-square-back.webp' },
    { name: 'Cufflinks', img: '/images/acc-cufflinks-catalog.webp', backImg: '/images/accessories-cufflinks-collection.webp' },
    { name: 'Leather Belt', img: '/images/acc-leather-belt.webp', backImg: '/images/acc-leather-belt.webp' },
    { name: 'Lapel Pin', img: '/images/acc-lapel-pins.webp', backImg: '/images/accessories-lapel-pins.webp' },
    { name: 'Bow Tie', img: '/images/acc-bowtie-card.webp', backImg: '/images/acc-bowtie-back.webp' },
    { name: 'Corsage & Boutonniere', img: '/images/acc-bridal-brooch.webp', backImg: '/images/acc-bridal-brooch-detail.webp' },
    { name: 'Collar Band', img: '/images/accessories-collar.webp', backImg: '/images/accessories-collar.webp' },
    { name: 'The Finishing Touch', img: '/images/acc-bowtie-2.webp', backImg: '/images/acc-bowtie-2.webp' },
  ];

  return (
    <>
      {/* Hero Section */}
      {/* Mobile banner */}
      <div className="block lg:hidden relative w-full overflow-hidden">
        <img src="/images/accessories-banner.webp" alt="Accessories" className="w-full h-auto object-contain" />
      </div>
      <div className="block lg:hidden px-6 py-6 bg-background-light dark:bg-background-dark">
        <span className="text-[10px] uppercase tracking-[0.5em] text-primary mb-4 block">Handcrafted Excellence</span>
        <h1 className="font-display text-4xl leading-[0.95] mb-4 dark:text-white">Accessories</h1>
        <div className="w-10 h-px bg-primary mb-4" />
        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">Curated pieces that complete the story of your garment.</p>
      </div>
      {/* Desktop banner */}
      <header className="hidden lg:block relative w-full lg:h-[70vh] overflow-hidden bg-background-light dark:bg-background-dark">
        <div className="relative z-10 flex flex-col justify-center w-full lg:w-[45%] lg:h-full px-6 sm:px-8 md:px-16 lg:px-20 py-8 lg:py-0 flex-shrink-0">
          <span className="text-[10px] uppercase tracking-[0.5em] text-primary mb-6">Handcrafted Excellence</span>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.95] mb-6 dark:text-white">Accessories</h1>
          <div className="w-10 h-px bg-primary mb-6" />
          <p className="text-gray-500 dark:text-gray-400 text-sm max-w-xs leading-relaxed">Curated pieces that complete the story of your garment.</p>
        </div>
        <div className="absolute inset-y-0 right-0 w-[65%] h-full">
          <img src="/images/accessories-banner.webp" alt="Accessories" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-background-light dark:from-background-dark to-transparent" />
        </div>
      </header>

      {/* Product Grid */}
      <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <p className="text-xs uppercase tracking-widest text-primary mb-4">Handcrafted Excellence</p>
          <h2 className="font-display text-3xl md:text-4xl mb-6">The Accessories Collection</h2>
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
            Every accessory is an extension of our tailoring philosophy — precision, material
            integrity, and lasting elegance.
          </p>
        </div>

        {/* 3x3 product grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {products.map((product) => (
            <div key={product.name} className="rounded-2xl overflow-hidden shadow-md bg-white dark:bg-surface-dark group">
              <div className="relative w-full overflow-hidden" style={{paddingBottom: '133%', height: 0}}>
                <img src={product.img} alt={product.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="hidden md:block absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="hidden md:block absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-display text-xl text-white mb-1">{product.name}</h3>
                </div>
              </div>
              <div className="block md:hidden px-3 py-2">
                <h3 className="font-display text-sm leading-tight dark:text-white">{product.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Accessories;
